import { render } from "./CWaiting.vue?vue&type=template&id=5f40a68d&scoped=true"
import script from "./CWaiting.vue?vue&type=script&lang=js"
export * from "./CWaiting.vue?vue&type=script&lang=js"

import "./CWaiting.vue?vue&type=style&index=0&id=5f40a68d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f40a68d"]])

export default __exports__